export const FormatPostcode = (postcode: string) => postcode?.trim().replace(/ /g, '').toLocaleUpperCase();